import React, { useState, useEffect } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import SplitNumber from "./SplitNumber";

import { isMobile } from "react-device-detect";
import AddToBasketRoundedButton from "./addToBasketRoundedButton";
import {
  IconBasket1,
  IconErrorCircle,
  IconStar,
  IconTooman,
} from "../../assets/icons";
import LazyLoad from "react-lazyload";
import Skeleton from "react-loading-skeleton";

import placeHolderimage from "../../assets/images/load-image.jpg";
import useLazyLoad from "./LazyImage";

function CardTileH6({
  itemImgSrc,
  amusementUrl,
  amusementName,
  amusementPrice,
  amusementFinalPrice,
  handleClick,
  hasReserveDetail_V2,
  tafrihanSuggestion,
  imageLabelJson,
}) {
  const [loaded, setLoaded] = useState(false);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [ref, inView] = useLazyLoad({ threshold: 0.1 }); // وقتی 10% المان در viewport باشد
  const [imgHeight, setImgHeight] = useState(0);
  const [imageLabels, setImageLabels] = useState([]);
  const imgWidth = isMobile ? "174px" : "194px";
  const imgHeightValue = isMobile ? "138px" : "150px";
  const skeletonStyle = {
    width: imgWidth,
    height: imgHeightValue,
  };

  useEffect(() => {
    var imageLabelList = JSON.parse(imageLabelJson || "[]");
    setImageLabels(imageLabelList);
  }, [imageLabelJson]);

  return isMobile ? (
    <Link to={amusementUrl}>
      <Card
        className={`p-1 rounded-3 text-center box-shadow-sm h-100  ${tafrihanSuggestion ? "special-offer" : ""
          }`}
      >
        {tafrihanSuggestion && (
          <div
            className="rounded-3 fs-07 center-tag-1 px-2 py-1 position-absolute"
            style={{ top: "0px", zIndex: "2" }}
          >
            <span className="small-svg">
              <IconStar fillColor="#9b8705" />
            </span>
            <span> پیشنهاد تفریحان</span>
          </div>
        )}

        {/* <LazyLoad> */}
        {/* <img
            src={itemImgSrc + "?width=200"}
            className="w-100 rounded-3"
            alt={amusementName}
            loading="lazy"
          /> */}
        <div
          ref={ref}
          style={{ position: "relative", width: "100%", height: "108px" }}
        >
          {/* تصویر پیش‌فرض (همیشه نمایش داده می‌شود) */}
          <img
            src={placeHolderimage}
            data-src={`${itemImgSrc}?width=200`}
            altBot={amusementName}
            alt=""
            aria-hidden="true"
            className="rounded-3 mb-1 w-100"
            style={{
              display: isImageLoaded ? "none" : "block", // پس از لود عکس اصلی، مخفی می‌شود
              objectFit: "cover",
              height: "100%",
              backgroundColor: "#f5f5f5", // رنگ پس‌زمینه برای حالت Placeholder
            }}
          />

          {/* تصویر اصلی (فقط وقتی در viewport باشد لود می‌شود) */}
          {inView && (
            <>
              <img
                src={`${itemImgSrc}?width=200`}
                alt={amusementName}
                className={`rounded-3 mb-1 w-100 ${isImageLoaded ? "visible" : "invisible"
                  }`}
                loading="lazy"
                onLoad={() => setIsImageLoaded(true)} // وقتی عکس لود شد، state را آپدیت می‌کند
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  height: "100%",
                  objectFit: "cover",
                }}
              />
              <div className="tag-on-pic">
                {imageLabels.map((label) => (
                  <div
                    key={label.id}
                    className="rounded-start-2 text-white fs-075 px-2 mt-1"
                    style={{ background: label.BackgroundColor }}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: label.LabelText,
                      }}
                    />
                  </div>
                ))}
              </div>
            </>
          )}

          {/* نسخه SEO برای موتور جستجو */}
          {/* <noscript>
            <img
              src={`${itemImgSrc}?width=200`}
              alt={amusementName}
              className="rounded-3 mb-1 w-100"
              style={{
                objectFit: "cover",
                height: "100%",
                width: "100%",
              }}
            />
          </noscript> */}
        </div>

        {/* </LazyLoad> */}
        <Card.Body className="mx-2 px-0 pt-2 pb-1 mb-1 border-bottom">
          <h3
            className="text-black d-inline-block mb-0 fw-bold fs-075"
            style={{ lineHeight: "1.2rem" }}
          >
            {amusementName}
          </h3>
        </Card.Body>
        {/* {hasReserveDetail_V2 ? ( */}
        <Card.Footer className="bg-white border-0 pb-2 pt-1 px-1 position-relative rounded-bottom-3">
          <Row className="gx-0">
            <Col className="my-auto">
              <div className="d-flex align-items-center justify-content-around">
                {amusementFinalPrice > amusementPrice && (
                  <>
                    <span className="text-black-06 fs-07 text-decoration-line-throught-rotate border-secondary">
                      <SplitNumber number={amusementFinalPrice} />
                    </span>
                    {/* <span className="fs-08 ps-1">تومان</span> */}
                  </>
                )}

                <div className="fw-bold text-black d-flex align-items-center">
                  <span className=" text-dark">
                    <SplitNumber number={amusementPrice} />
                  </span>
                  <span className=" mb-2 medium-svg">
                    <IconTooman fillColor="#000" />
                  </span>
                </div>
              </div>
            </Col>
            {hasReserveDetail_V2 ?
              <Col xs="12" className="my-auto">
                <AddToBasketRoundedButton onClick={handleClick} />
              </Col> :
              <Col xs="12" className="my-auto fs-065">
                <Button
                  variant="outline-secondary"
                  className="btn-outline-Secondary btn-sm small-svg  rounded-2 fs-07 w-90 opacity-50"
                >
                  <IconBasket1 fillColor="#6c757d" />
                  <span className="ps-1">خرید بلیط</span>
                </Button>
              </Col>}
          </Row>
        </Card.Footer>
        {/* ) : (
          <Card.Footer className="bg-white border-0 pb-2 pt-2 px-1 position-relative rounded-bottom-3">
          <Row className="gx-0">
            <Col xs="12" className="my-auto opacity-50">
              <div className="d-flex align-items-center justify-content-around">
                <div className="pb-2 text-black d-flex align-items-center fs-07">
                  در حال حاضر رزرو غیرفعال است
                  </div>
              </div>
            </Col>
            <Col xs="12" className="my-auto fs-065">
              <Button
                variant="outline-secondary"
                className="btn-outline-Secondary btn-sm small-svg  rounded-2 fs-07 w-90 opacity-50"
              >
                <IconBasket1 fillColor="#6c757d" />

                <span className="ps-1">خرید بلیط</span>
              </Button>
            </Col>
          </Row>
        </Card.Footer>
        )} */}
      </Card>
    </Link>
  ) : (
    <Link to={amusementUrl}>
      <Card
        className={`p-2 rounded-3 text-center box-shadow-sm h-100  ${tafrihanSuggestion ? "special-offer" : ""
          }`}
      >
        {/* {tafrihanSuggestion && (
          <div
            className=" text-white  rounded-3 fs-07 center-tag px-2 py-1 position-absolute"
            style={{ bottom: "0px", zIndex: "2" }}
          >
            <span className="small-svg">
              <IconOffer fillColor="#e54707" />
            </span>
            <span> پیشنهاد تفریحان</span>
          </div>
        )} */}
        {tafrihanSuggestion && (
          <div
            className="  rounded-3 fs-07 center-tag-1 px-2 py-1 position-absolute"
            style={{ top: "-6px", zIndex: "2" }}
          >
            <span className="small-svg">
              <IconStar fillColor="#9b8705" />
            </span>
            <span> پیشنهاد تفریحان</span>
          </div>
        )}

        <div
          ref={ref}
          style={{ position: "relative", width: "100%", height: "150px" }}
        >
          {/* تصویر پیش‌فرض (همیشه نمایش داده می‌شود) */}
          <img
            src={placeHolderimage}
            data-src={`${itemImgSrc}?width=210`}
            altBot={amusementName}
            alt=""
            aria-hidden="true"
            className="rounded-3 mb-1 w-100"
            style={{
              display: isImageLoaded ? "none" : "block", // پس از لود عکس اصلی، مخفی می‌شود
              objectFit: "cover",
              height: "100%",
              backgroundColor: "#f5f5f5", // رنگ پس‌زمینه برای حالت Placeholder
            }}
          />

          {/* تصویر اصلی (فقط وقتی در viewport باشد لود می‌شود) */}
          {inView && (
            <>
              <img
                src={`${itemImgSrc}?width=210`}
                alt={amusementName}
                className={`rounded-3 mb-1 w-100 ${isImageLoaded ? "visible" : "invisible"
                  }`}
                loading="lazy"
                onLoad={() => setIsImageLoaded(true)} // وقتی عکس لود شد، state را آپدیت می‌کند
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  height: "100%",
                  objectFit: "cover",
                }}
              />
              <div className="tag-on-pic">
                {imageLabels.map((label) => (
                  <div
                    key={label.id}
                    className="rounded-start-2 text-white fs-075 px-2 mt-1"
                    style={{ background: label.BackgroundColor }}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: label.LabelText,
                      }}
                    />
                  </div>
                ))}
              </div>
            </>
          )}

          {/* نسخه SEO برای موتور جستجو */}
          {/* <noscript>
            <img
              src={`${itemImgSrc}?width=200`}
              alt={amusementName}
              className="rounded-3 mb-1 w-100"
              style={{
                objectFit: "cover",
                height: "100%",
                width: "100%",
              }}
            />
          </noscript> */}
        </div>
        {/* <div
            style={{
              position: "relative",
              width: "100%",
              height: imgHeightValue,
            }}
          >
            {!loaded && (
              <Skeleton style={skeletonStyle} className="rounded-3" />
            )}
            <img
              data-src={`${itemImgSrc}?width=210`}
              src={itemImgSrc + "?width=210"}
              alt={amusementName}
              className="rounded-3 mb-1"
              style={{
                display: loaded ? "block" : "none",
                width: "100%",
                height: "100%",
              }}
              onLoad={() => setLoaded(true)}
            />
            <div className="tag-on-pic">
              {imageLabels.map((label) => (
                <div
                  key={label.id}
                  className="  rounded-start-2 text-white fs-075 px-2 mt-1"
                  style={{ background: label.BackgroundColor }}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: label.LabelText,
                    }}
                  />
                </div>
              ))}
            </div>
          </div> */}
        <Card.Body className="px-0 pb-0">
          <h3 className="text-black fw-bold fs-normal pb-3 border-bottom">
            {amusementName}
          </h3>

          {/* <AddToBasketButton
            
            price={amusementFinalPrice}
          /> */}
        </Card.Body>
        {/* {hasReserveDetail_V2 ? ( */}
        <Card.Footer className="bg-white border-0 pb-2 pt-1 px-1 position-relative rounded-bottom-3">
          <Row className="gx-0">
            <Col className="my-auto">
              <div className="d-flex align-items-center justify-content-around">
                {amusementFinalPrice > amusementPrice && (
                  <>
                    <span className="text-black-06 fs-07 text-decoration-line-throught-rotate border-secondary">
                      <SplitNumber number={amusementFinalPrice} />
                    </span>
                    {/* <span className="fs-08 ps-1">تومان</span> */}
                  </>
                )}

                <div className="fw-bold text-black d-flex align-items-center">
                  <span className=" text-dark">
                    <SplitNumber number={amusementPrice} />
                  </span>
                  <span className=" mb-2 medium-svg">
                    <IconTooman fillColor="#000" />
                  </span>
                </div>
              </div>
            </Col>
            <Col xs="12" className="my-auto">
              {hasReserveDetail_V2 ? <AddToBasketRoundedButton onClick={handleClick} /> :
                <Row className="gx-0">
                  <Col xs="12" className="my-auto fs-065">
                    <div className="btn btn-outline-Secondary btn-sm small-svg border-secondary rounded-2 fs-085 w-90 opacity-50">
                      <IconBasket1 fillColor="#6c757d" />

                      <span className="ps-1">خرید بلیط</span>
                    </div>
                  </Col>
                </Row>}
            </Col>
          </Row>
        </Card.Footer>
        {/* ) : (
          <Card.Footer className="bg-white border-0 pb-2 pt-2 px-1 position-relative rounded-bottom-3">
            <Row className="gx-0">
              <Col xs="12" className="my-auto opacity-50">
                <div className="d-flex align-items-center justify-content-around">
                  <div className="pb-2 text-black d-flex align-items-center fs-07">
                    در حال حاضر رزرو غیرفعال است
                  </div>
                </div>
              </Col>
              <Col xs="12" className="my-auto fs-065">
                <div className="btn btn-outline-Secondary btn-sm small-svg border-secondary rounded-2 fs-085 w-90 opacity-50">
                  <IconBasket1 fillColor="#6c757d" />

                  <span className="ps-1">خرید بلیط</span>
                </div>
              </Col>
            </Row>
          </Card.Footer>
        )} */}
        {/* {hasReserveDetail_V2 ? (
          <Card.Footer
            className={`bg-white border-0 px-0 position-relative pb-1 `}
          >
            <Row className="gx-0">
              <Col className="my-auto">
                {amusementFinalPrice > amusementPrice ? (
                  <>
                    <span className="text-black-06 fs-08 text-decoration-line-throught-rotate border-secondary">
                      <SplitNumber number={amusementFinalPrice} />
                    </span>
                    <span className="fs-08 ps-1">تومان</span>
                  </>
                ) : (
                  ""
                )}
                <div className="fw-bold text-black">
                  <span className=" text-dark pe-1">
                    <SplitNumber number={amusementPrice} />
                  </span>
                  تومان
                </div>
              </Col>
              <Col xs="auto" className="my-auto">
                <AddToBasketRoundedButton onClick={handleClick} />
              </Col>
            </Row>
          </Card.Footer>
        ) : (
          <Card.Footer className="bg-white border-0 px-0 pb-1 fs-07">
            <IconErrorCircle fillColor="#444" />
            در حال حاضر رزرو غیرفعال است
          </Card.Footer>
        )} */}
      </Card>
    </Link>
  );
}
export default CardTileH6;
